<div class="{{styles.productProp}} clear">{{each props.info info key}} {{ if info.type === 3}}<oy-select data-key="{{key}}"></oy-select>{{ else if info.type === 14}}<oy-dropdown-input data-key="{{key}}"></oy-dropdown-input>{{ else if info.type === 15}}<oy-dropdown-input-range data-key="{{key}}"></oy-dropdown-input-range>{{/if}} {{/each}}</div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilter/components/OYProductProp/index.art